import React, { useState } from "react";
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, TextField, Typography, Box, Rating } from "@mui/material";
import { sendFeedback } from "./api/sendFeedback";

const FeedbackPopup = ({ open, onClose }) => {
  const [rating, setRating] = useState(0);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async () => {
    if (rating === 0) {
      setError("Please provide a star rating.");
      return;
    }

    const result = await sendFeedback(rating, message);

    if (result === "Feedback sent successfully!") {
      onClose(); // Close the popup after successful submission
    } else {
      setError("Failed to send feedback. Please try again later.");
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>We Value Your Feedback</DialogTitle>
      <DialogContent>
        <Box display="flex" flexDirection="column" gap={2}>
          <Typography variant="body1">Rate your experience:</Typography>
          <Rating
            name="rating"
            value={rating}
            onChange={(event, newValue) => setRating(newValue)}
          />

          <Typography variant="body1">Leave a message (optional):</Typography>
          <TextField
            fullWidth
            multiline
            rows={4}
            variant="outlined"
            placeholder="Share your feedback..."
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          />

          {error && <Typography color="error">{error}</Typography>}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined" color="secondary">
          Cancel
        </Button>
        <Button onClick={handleSubmit} variant="contained" color="primary">
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FeedbackPopup;
